import React from "react";
import useEditList from "./useEditList";
import useTempAction from "./useTempAction";
const defaultConfig = {
    getId: (item) => item.id || item.toString(),
};
export default function useTempList(list, config = defaultConfig) {
    const [editList, editActions] = useEditList(list, config);
    const [tempList, tempAdd] = useTempAction();
    const add = React.useMemo(() => (item, promise) => {
        tempAdd(item, () => promise().then(() => editActions.update(item)));
    }, [editActions, tempAdd]);
    const remove = React.useMemo(() => (item, promise) => {
        editActions.deleteItem(config.getId(item));
        tempAdd(item, () => promise().catch(() => editActions.update(item)));
    }, [config, editActions, tempAdd]);
    // @ts-expect-error - TS2322 - Type 'unknown[]' is not assignable to type 'T[]'.
    return [editList, tempList, { add, remove }];
}
